import React from 'react';
import { Divider, notification } from 'antd';
import { showNotification, styleNotification } from './notificationConfig';
import { warning } from './notificationTypes';
import { Row, Icon, Text } from '../../common';

export const reactivateAlertSoundNotification = () => {
    const { msg, backgroundColor, icon, color, borderColor } = warning;
    const key = Date.now()

    showNotification({
        message: (
            <Row align='center'>
                <Icon name={icon} size={24} color={color} />
                <Divider type='vertical' style={{ background: color, height: '3em', margin: '0px 14px 0px 14px', width: '0.15em', top: 0 }} />
                <Text text={msg} size={12} underlineOnHover strong color={color} onClick={() => notification.close(key)} style={{ cursor: 'pointer' }} />
            </Row>
        ),
        key,
        style: { ...styleNotification, backgroundColor, border: `1px solid ${borderColor}`, height: 76 }
    });
};